var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69316 13.9007C5.7133 13.9124 5.72913 13.9214 5.74034 13.9277L5.75895 13.9381C5.90753 14.0196 6.09184 14.019 6.24056 13.9383L6.25966 13.9277C6.27087 13.9214 6.2867 13.9124 6.30684 13.9007C6.34711 13.8774 6.40465 13.8433 6.477 13.7988C6.62164 13.7097 6.82583 13.5784 7.06974 13.4061C7.55673 13.0621 8.2065 12.5516 8.8577 11.8849C10.1538 10.5579 11.5 8.56411 11.5 6C11.5 2.96243 9.03757 0.5 6 0.5C2.96243 0.5 0.5 2.96243 0.5 6C0.5 8.56411 1.84622 10.5579 3.1423 11.8849C3.7935 12.5516 4.44327 13.0621 4.93026 13.4061C5.17417 13.5784 5.37836 13.7097 5.523 13.7988C5.59535 13.8433 5.65289 13.8774 5.69316 13.9007ZM6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8Z",
    fill: "#818385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/IconPin.2f597ceedf7d600e6cfe241a22fce56a.svg";
export { ForwardRef as ReactComponent };